import { css } from 'styled-components';
import * as Colors from '../consts/palette/colors';
const colorLabelMap = new Map([['redPink', Colors.RED_PINK], ['red', Colors.RED], ['orange', Colors.ORANGE], ['lightOrange', Colors.LIGHT_ORANGE], ['campaignOrange', Colors.CAMPAIGN_ORANGE], ['lightBlue', Colors.LIGHT_BLUE], ['grey', Colors.GREY], ['lightGrey', Colors.LIGHT_GREY], ['blue', Colors.BLUE], ['green', Colors.GREEN], ['lightGreen', Colors.LIGHT_GREEN], ['purple', Colors.PURPLE], ['grey4', Colors.GREY4], ['grey8', Colors.GREY8], ['grey16', Colors.GREY16], ['grey24', Colors.GREY24], ['grey48', Colors.GREY48], ['grey80', Colors.GREY80], ['grey56', Colors.GREY56], ['white', Colors.WHITE], ['black', Colors.BLACK], ['transparent', Colors.TRANSPARENT]]);
export const mapColorLabelToHex = colorLabel => {
  // If no color is provided, use the default.
  const hex = colorLabelMap.get(colorLabel);
  return hex;
};
export const backgroundColor = () => css(["", ";"], _ref => {
  let {
    color
  } = _ref;
  return `background-color: ${mapColorLabelToHex(color)};`;
});
export const color = css(["", ";"], _ref2 => {
  let {
    color
  } = _ref2;
  return `color: ${mapColorLabelToHex(color)};`;
});